import type { EmojiGroup } from "./emojiSet.generated";

/* The emoji picker's two small rules, pure so a test can run them: SEARCH (every word typed is found in the emoji's name —
 * `thumb up` finds 👍, `fire` finds 🔥) and RECENT (this browser's last picks, newest first, a convenience — localStorage,
 * never trusted, never required: a blocked store answers an empty list and the picker still works). */

export function emojiMatches(groups: readonly EmojiGroup[], query: string): (readonly [string, string])[] {
  const words = query.toLowerCase().split(/\s+/).filter((w) => w !== "");
  if (words.length === 0) return [];
  const out: (readonly [string, string])[] = [];
  for (const g of groups) for (const pair of g.emojis) {
    const name = pair[1].toLowerCase();
    if (words.every((w) => name.includes(w))) out.push(pair);
  }
  return out;
}

export const RECENT_KEY = "ht-emoji-recent";
export const RECENT_MAX = 12;

export function readRecent(): string[] {
  try {
    const raw = window.localStorage.getItem(RECENT_KEY);
    const list: unknown = raw === null ? [] : JSON.parse(raw);
    return Array.isArray(list) ? list.filter((e): e is string => typeof e === "string").slice(0, RECENT_MAX) : [];
  } catch {
    return [];
  }
}

export function nextRecent(list: readonly string[], picked: string): string[] {
  return [picked, ...list.filter((e) => e !== picked)].slice(0, RECENT_MAX);
}

export function pushRecent(picked: string): void {
  try {
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(nextRecent(readRecent(), picked)));
  } catch {
    // A convenience only: a private window or blocked storage forgets, and nothing else changes.
  }
}
